import { useState } from 'react';
import { LibraryItem } from './hooks/useLibrary';
import { cn } from '@/src/lib/utils';
import DeviceAwareImage from '../../../ExperienceBuilder/DeviceAwareImage';

// Removed styled ImagePreview - now using DeviceAwareImage component

export default function LibraryLists({
    files,
    onImageSelected,
}: {
    files: LibraryItem[];
    onImageSelected: (image: string) => void;
}) {
    const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
    return (
        <div className="relative">
            <ul className="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-4 xl:gap-x-8 max-h-[75vh] overflow-y-auto py-2 z-1">
                {files.map((file, index) => (
                    <li
                        key={file.url}
                        className={cn('relative')}
                        onClick={(e) => {
                            e.stopPropagation();
                            setSelectedIndex(index);
                            onImageSelected(file.url);
                        }}
                    >
                        <ImageCell
                            file={file}
                            selected={selectedIndex === index}
                        />
                    </li>
                ))}
            </ul>
        </div>
    );
}

function ImageCell({
    file,
    selected,
}: {
    file: LibraryItem;
    selected: boolean;
}) {
    return (
        <div className="rounded-lg bg-muted focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 border-2 border-solid">
            <div className="text-sm text-foreground px-2 justify-center">
                <div className="flex flex-row justify-center items-center">
                    {file.name}
                </div>
            </div>
            <div
                className={cn(
                    'group relative overflow-hidden min-h-[200px] flex justify-center items-center',
                    selected && 'bg-primary/50',
                )}
            >
                <DeviceAwareImage
                    src={file.url}
                    alt=""
                    maxWidth={200}
                    maxHeight={200}
                    showDimensions={true}
                    isHovering={false}
                />
            </div>
        </div>
    );
}
